<template>
    <div class="base-indulge" :class="{'indulge-sp': $store.state.screen == 1}">
        <div class="header">
            <div class="back-img" @click="$router.back()">
                <img class="back" src="~images/back.png" />
            </div>
            <div class="title">防沉迷政策</div>
            <div class="service-img" @click="$router.push('/base-service')">
                <img class="ser" src="~images/user_service.png" />
            </div>
        </div>
        <div class="content">
            <div class="explain">为规范网络游戏服务，国家新闻出版署发布《关于防止未成年人沉迷网络游戏的通知》：</div>
            <div class="title">一、实行网络游戏用户账号实名注册注册制度</div>
            <div class="explain">严格实名，所有网络游戏用户均须使用有效身份信息方可进行游戏账号注册</div>
            <div class="title">二、严格控制未成年人使用网络游戏时段、时长</div>
            <div class="explain">
                每日22时至次日8时，网络游戏企业不得以任何形式为未成年人提供游戏服务，法定节假日每日累计不得超过3小时，其他时间每日累计不得超过1.5小时。
            </div>
            <div class="title">三、规范向未成年人提供付费服务</div>
            <div class="explain">网络游戏企业不得为未满8周岁的用户提供游戏付费服务。</div>
            <div class="explain">同一网络游戏企业所提供的游戏付费服务</div>
            <div class="explain">• 8周岁以上未满16周岁的用户,单次充值金额不得超过50元人民币,每月充值金额累计不得超过200元人民币</div>
            <div class="explain lase">• 16周岁以上未满18周岁的用户,单次充值金额不得超过100元人民币,每月充值金额累计不得超过400元人民币</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BaseIndulge'
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22;
    // 横屏css
    .base-indulge {
        width: 1080px;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        flex-direction: column;
        transition: all 0.3s;
        .header {
            height: 132px;
            background: rgba($color, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .back-img {
                width: 192px;
                height: 132px;
                position: absolute;
                left: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                .back {
                    width: 72px;
                    height: 72px;
                }
            }
            .title {
                font-size: 51px;
                text-align: center;
            }
            .service-img {
                width: 192px;
                height: 132px;
                position: absolute;
                right: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                .ser {
                    width: 72px;
                    height: 72px;
                }
            }
        }
        .content {
            flex: 1;
            overflow-y: scroll;
            padding: 80px 60px 0;
            .explain {
                font-size: 39px;
                margin-bottom: 60px;
            }
            .title {
                font-size: 45px;
                margin-bottom: 60px;
            }
            .lase {
                margin-bottom: 60px;
            }
        }
    }
    // 竖屏css
    .indulge-sp {
        width: 100%;
        height: 100%;
        .header {
            height: 240px;
            border-radius: 60px 0 0 0;
            .back-img {
                width: 290px;
                height: 240px;
                .back {
                    width: 130px;
                    height: 130px;
                }
            }
            .title {
                font-size: 92px;
            }
            .service-img {
                width: 290px;
                height: 240px;
                .ser {
                    width: 130px;
                    height: 130px;
                }
            }
        }
        .content {
            padding: 145px 90px 0;
            .explain {
                font-size: 70px;
                margin-bottom: 90px;
            }
            .title {
                font-size: 70px;
                margin-bottom: 90px;
            }
            .lase {
                margin-bottom: 90px;
            }
        }
    }
</style>